import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import PlatformConfig from '@/store/modules/config'
import { Route } from 'vue-router'
const service = axios.create({
  baseURL: PlatformConfig.baseServerUrlApi,
  timeout: 500000
})

// Request interceptors
service.interceptors.request.use(
  (config) => {
    // Add X-Access-Token header to every request, you can add other custom headers here
    if (UserModule.token) {
      config.headers['Authorization'] = `Bearer ${UserModule.token}`
    }
    if (config.method === 'get') {
      config.params = {
        t: Date.parse(new Date().toString()) / 1000,
        ...config.params
      }
    }
    // config.params = {
    //   t: Date.parse(new Date().toString()) / 1000,
    //   ...config.params
    // }
    return config
  },
  (error) => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  (response) => {
    // Some example codes here:
    // code == 20000: success
    // code == 50001: invalid access token
    // code == 50002: already login in other place
    // code == 50003: access token expired
    // code == 50004: invalid user (user not exist)
    // code == 50005: username or password is incorrect
    // You can change this part for your own usage.
    const res = response.data
    // if (res.code !== 200) {
    //   Message({
    //     message: res.message || 'Error1',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     MessageBox.confirm(
    //       'You have been logged out, try to login again.',
    //       'Log out',
    //       {
    //         confirmButtonText: 'Relogin',
    //         cancelButtonText: 'Cancel',
    //         type: 'warning'
    //       }
    //     ).then(() => {
    //       UserModule.ResetToken()
    //       location.reload() // To prevent bugs from vue-router
    //     })
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return response.data
    // }
    return response.data
  },
  (error) => {
    // if (error.request) {
    //   console.log(error.request)
    // } else if (error.response) {
    //   console.log(error.response.data)
    //   console.log(error.response.status)
    //   console.log(error.response.headers)
    // }
    if (error && error.response) {
      switch (error.response.status) {
        case 400: error.message = '请求错误(400)'
          break
        case 401: error.message = '登录超时，请重新登录(401)'
          break
        case 403: error.message = '拒绝访问(403)'
          break
        case 404: error.message = '请求出错(404)'
          break
        case 500: error.message = '服务器错误(500)'
          break
      }
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      console.log(error.message)
    } else {
      error.message = '连接服务器失败!'
    }
    return Promise.reject(error)
  }
)

export default service
